import React from 'react';

import { withDocumentTitle } from '../../generic/DocumentTitle';
import add from '../../REST/add';
import api from '../../REST/api';
import { tapFlashSuccess } from '../../utils/flash';
import ContactListForm from './ContactListForm';

const AddContactList = add({
  default: {
    name: '',
    description: '',
  },
  update: (props, model) =>
    api
      .addContactList({
        data: model,
      })
      .then(tapFlashSuccess('Created Contact list')),
  form: props => <ContactListForm newModel {...props} />,
  redirectTo: '/contacts/contact-lists/:id/show',
});

export default withDocumentTitle('Create Contact-List')(AddContactList);
